import { Fragment } from "react"
import FieldChanger from "../FieldChanger"
import { schema } from "src/modules/pe-landing-module/data/schema"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface ILandingSettingFormProps {
   
}
const LandingSettingForm = (props: ILandingSettingFormProps): JSX.Element => {
    const dataSchema = schema().Landing
    const currentEditData = useLandingStore((state:ILandingStore) => state.currentLanding)
    const onChange = (value: any, _field: string, data: any, field: string) => {
        
        console.log( value, _field, data, field, )
        
    }

    return <div className="landing-edit-layer"> 
        <div className="panel-list-2 overflow-y-auto pb-3"> 
            { 
                Object.keys( dataSchema.apollo_fields )
                    .filter(field => dataSchema && 
                        dataSchema.apollo_fields[ field ].tab === "main" && 
                        !dataSchema.apollo_fields[ field ].isHidden 
                    )
                    .map((field: any) => {
                        return <Fragment key={ field }>
                            <FieldChanger 
                                {...dataSchema.apollo_fields[ field ]}
                                field={ field }
                                value={ currentEditData[field] }
                                origin={currentEditData}
                                onChange={ ( value: any, _field: string, data: any ) => onChange(value, _field, data, field) }
                                notClear
                            />
                        </Fragment>
                    })
            }    
        </div>
    </div>
}
export default LandingSettingForm